
















































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { StepMixin, StepStoreMixin, StoreFileMixin, ErrorResponseMixin, PopupMixin } from '@mixin';
import { app } from '@config';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            prev: false,
            store: {
                organisation: {
                    kvk: '',
                },
            },
            post: {
                file: null,
                owner: 'organisation',
                type: 'kvk',
            },
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin,
        StoreFileMixin,
        ErrorResponseMixin,
        PopupMixin,
    ],

    created() {
        this.post.id = this.current.organisation_id;
        this.downloadFile(this.post);
    },

    methods: {

        async onNext() {
            if (this.store.organisation.kvk) {
                return await this.$validator.validate().then(valid => {
                    if (!valid) return false;
                    return this.storeFile(this.post);
                });
            } else {
                return await this.storeFile(this.post);
            }
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Kvk extends Vue {}

